<template>
  <div class="hide-indicators-options-field" @click="displayed = true">
    <EditableLabel
      :value="displayedText"
      :legend="$t('message.HIDE_SOME_INDICATORS') + $t('message.TWO_DOTS')"
      disabled
    />
    <HideIndicatorsOptions
      :value="value"
      :displayed="displayed"
      :themes="themes"
      @input="$emit('input', $event)"
      @close="displayed = false"
    />
  </div>
</template>

<script>
/**
 * Simple field to trigger HideIndicatorsOptions edition
 */

import EditableLabel from '@/components/editable-label.vue';
import HideIndicatorsOptions from '@/components/hide-indicators-options.vue';

export default {
  name: 'HideIndicatorsOptionsField',

  components: {
    EditableLabel,
    HideIndicatorsOptions,
  },

  props: {
    value: {
      type: Array,
      required: true,
    },
    themes: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      displayed: false,
    };
  },

  computed: {
    /** String: Tell the users how many indicators are hidden */
    displayedText() {
      const indicators = this.themes
        .flatMap(theme => theme.indicators)
        .filter(i => this.value.includes(i.id));
      return this.$tc('message.N_HIDDEN_INDICATORS', indicators.length, { nb: indicators.length });
    },
  },

};
</script>

<style lang="scss">
.hide-indicators-options-field {
  .editable-label {
    cursor: pointer;
  }
}
</style>
